export const theme = {
  colors: {
    background: "#1a1a1a",
    backgroundAlt: "#222222",
    border: "#3a3a3a",
    borderActive: "#5a5a5a",
    accent: "#6699cc",
    text: "#e0e0e0",
    textBright: "#ffffff",
    textDim: "#666666",
    number: "#88ccaa",
    string: "#e0e0e0",
    null: "#666666",
    highlight: "#ffcc66",
    selected: "#2d4f67",
    selectedBorder: "#6699cc",
    error: "#cc6666",
    success: "#99cc99",
    modalOverlay: "rgba(0, 0, 0, 0.5)",
  },
  borders: {
    single: "single" as const,
    double: "double" as const,
    rounded: "rounded" as const,
  },
}
